<template>
	<div class="tabbar">
		<slot></slot>
	</div>
</template>

<script>
	export default {
		name:'Tabbar'
	}
</script>

<style>
	.tabbar{
		display: flex;
		justify-content: space-around;
		align-items: center;
		
		position: fixed;
		left: 0;
		bottom: 0;
		right: 0;
		
		height: 50px;
		background-color: #f0f0f0;
		font-size: 12px;
	}
</style>
